import Vue from 'vue';
import VueI18n from 'vue-i18n';

/// #if PROD
import en from '../lang/en.json';
const messages = { en };
/// #else
// #code import messages from '@/lang';
/// #endif

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
});

export const changeLocale = async lang => {
  try {
    if (!messages[lang]) {
      messages[lang] = await import(`../lang/${lang}.json`);
    }
    i18n.setLocaleMessage(lang, messages[lang]);
    i18n.locale = lang;
  } catch (e) {
    // generate json files when error appears (npm run genI18n)
    console.error(e);
  }
};

export default i18n;
